export default __webpack_public_path__ + "static/6644-b62ce7ad4375824f790b2aaafddc1a91.jpg";